import { useTranslate } from "@similarweb/i18n-provider";
import { IconButton } from "@similarweb/ui-components";

import { swSettings } from "app/common/services/swSettings";
import trackingService from "app/pages/sales-intelligence/modules/lists/services/tracking/trackingService";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import { openHooksModalV5 } from "app/services/ModalService";
import { goToAddonsPage } from "app/UtilitiesAndConstants/UtilityFunctions/goToAddonsPage";
import { hasAddonsEnabled, isNoTouch } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

import type { AssignToOtherUsersButtonBaseContainerProps } from "./AssignToOtherUsersButtonBaseContainer";
import AssignToOtherUsersButtonBaseContainer from "./AssignToOtherUsersButtonBaseContainer";

const AssignToOtherUsersButtonClaimContainer = (props: AssignToOtherUsersButtonBaseContainerProps) => {
    const { translate } = useTranslate();
    const isNTUser = isNoTouch(swSettings);

    if (!salesSettingsHelper.isAssignToOtherUsersEnabled() || isNTUser) {
        return (
            <IconButton
                type="flatTrial"
                iconName="sparkles"
                isDisabled={props.isDisabled}
                onClick={() => {
                    trackingService.trackAssignHookClick();

                    if (isNTUser && hasAddonsEnabled(swSettings)) {
                        goToAddonsPage();
                        return;
                    }

                    openHooksModalV5("SalesSolutionLists");
                }}
            >
                {translate("si.multi_selector.assign.btn.title")}
            </IconButton>
        );
    }

    return <AssignToOtherUsersButtonBaseContainer {...props} />;
};

export default AssignToOtherUsersButtonClaimContainer;
